import React from 'react';
import ControlledInput from './controlledInput'
import api from './apiConnector'

class LoginBox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            login:'',
            password:''
        }
    }

    onLogin() {
        api.login(
            this.state.login,
            this.state.password
          )
    }

    render() {
        return <div className="login_container">
            <div className='login_box'>
            <h1>Backoffice AssurBonPlan Xenassur</h1>
            <table>
                <tbody>
                    <tr>
                        <th>Votre login</th>
                        <td><ControlledInput type='text' property='login' container={this} onSubmit={this.onLogin.bind(this)}/></td>
                    </tr>
                    <tr>
                        <th>Votre mot de passe</th>
                        <td><ControlledInput type='password' property='password' container={this} onSubmit={this.onLogin.bind(this)}/></td>
                    </tr>
                    <tr>
                        <th colSpan="2" className="button_row">
                            <input type='button' className='main_button' value='Login' onClick={this.onLogin.bind(this)} 
                                disabled={!( this.state.login && this.state.password )}/>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
        </div>
    }
}

export default LoginBox;
